import BaseCollection from '@/collections/BaseCollection';

/**
 * Cashier service base collection class
 */
export default class CashierServiceCollection extends BaseCollection {

  constructor(){
    super();
  }

  // Route configuration
  privateRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/' + model.modelName(),
    }
  }
}
